module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/disabled-pattern.5cf7a388.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/disabled-pattern.png
// module id = 2540
// module chunks = 11